import * as React from 'react';
import styled from '@emotion/styled';

import CodeBlock from './codeBlock';
import AnchorTag from './anchor';

/**
 * Styled pre wrapper for code blocks
 * Uses CSS variables for theme-aware styling
 */
const StyledPre = styled('div')`
  background: var(--color-bg-surface);
  border-radius: var(--radius-lg, 8px);
  margin: 0 0 var(--gap-3x, 15px) 0;
  overflow-x: auto;
`;

/**
 * Helper function to extract text content from React children
 */
const appendString = (children) => {
  if (Array.isArray(children)) {
    return children.reduce((acc, current) => {
      if (typeof current === 'string') {
        return acc.concat(current);
      } else if (typeof current === 'object') {
        return acc.concat(current.props.children);
      } else {
        return acc;
      }
    }, '');
  } else {
    return children;
  }
};

/**
 * MDX Component mappings
 * Updated to match Figma design specifications
 */
export default {
  h1: (props) => (
    <h1
      className="heading1"
      id={appendString(props.children).replace(/\s+/g, '').toLowerCase()}
      {...props}
    />
  ),
  h2: (props) => (
    <h2
      className="heading2"
      id={appendString(props.children).replace(/\s+/g, '').toLowerCase()}
      {...props}
    />
  ),
  h3: (props) => (
    <h3
      className="heading3"
      id={appendString(props.children).replace(/\s+/g, '').toLowerCase()}
      {...props}
    />
  ),
  h4: (props) => (
    <h4
      className="heading4"
      id={appendString(props.children).replace(/\s+/g, '').toLowerCase()}
      {...props}
    />
  ),
  h5: (props) => (
    <h5
      className="heading5"
      id={appendString(props.children).replace(/\s+/g, '').toLowerCase()}
      {...props}
    />
  ),
  h6: (props) => (
    <h6
      className="heading6"
      id={appendString(props.children).replace(/\s+/g, '').toLowerCase()}
      {...props}
    />
  ),
  p: (props) => <p className="paragraph" {...props} />,
  pre: (props) => (
    <StyledPre className='code-block' {...props} />
  ),
  code: CodeBlock,
  a: AnchorTag,
  blockquote: (props) => <blockquote className='blockquote' {...props} />,
  ul: (props) => <ul className='list' {...props} />,
  ol: (props) => <ol className='list' {...props} />,
  li: (props) => <li className='list-item' {...props} />,
  table: (props) => <table className='table' {...props} />,
  thead: (props) => <thead {...props} />,
  tbody: (props) => <tbody {...props} />,
  tr: (props) => <tr {...props} />,
  th: (props) => <th {...props} />,
  td: (props) => <td {...props} />,
  img: (props) => <img className='img' {...props} alt={props.alt || ''} />,
};
